export default __webpack_public_path__ + "static/media/posterLigaJabar.9fe22ee9.png";